import { render, staticRenderFns } from "./zhj.vue?vue&type=template&id=45828f6e&scoped=true&"
import script from "./zhj.vue?vue&type=script&lang=js&"
export * from "./zhj.vue?vue&type=script&lang=js&"
import style0 from "./zhj.vue?vue&type=style&index=0&id=45828f6e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45828f6e",
  null
  
)

export default component.exports